



































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { hasAuth } from '@/utils/validate';
import { D_BRAND_AUTH } from '@/menu/auth-const';
import { initPageParams } from '@/utils/constants';
import { renderBool } from '@/utils/renderer';
import { IPageParam } from '@/store/types';
import { IAuthedBrandRecord } from '@/store/organization/org/types';
import { IActions, IBrandAuthPage } from '@/store/brand-audit/auth/types';
import PageList from '@/components/page/Index.vue';
import OrgAuthList from './OrgAuthList.vue';

const Auth = namespace('brandAudit/auth');

// 当前组织已授权的品牌列表
@Component({
  components: { PageList, OrgAuthList },
})
export default class EnterpriseBrandAuth extends Vue {
  @Auth.Action('queryAuthBrandPage') public queryAuthedBrandPage!: IActions['queryAuthBrandPage'];
  @Auth.State('authBrandPage') public list!: IBrandAuthPage;

  @Auth.Action('checkOwnerBrand') public checkOwnerBrand!: IActions['checkOwnerBrand'];

  public hasBrandAuth = hasAuth([D_BRAND_AUTH]);  // 是否拥有'品牌授权管理'权限
  public ossHost = process.env.VUE_APP_RES_OSS_URL as string;

  public expandType = '';
  public expanded: IAuthedBrandRecord[] = [];

  public headers = [
    { text: '缩略图', value: 'thumb' },
    { text: '品牌编码', value: 'brandCode' },
    { text: '品牌品牌名称', value: 'nameChn' },
    { text: '品牌拥有者', value: 'isOwner' },
    { text: '公共品牌', value: 'isPublic' },
  ];

  public created() {
    this.checkOwnerBrand();
    this.queryAuthedBrandPage(initPageParams);
  }

  // 展开或收起
  public toggleExpand(record: IAuthedBrandRecord, type: string) {
    const expandId = this.expanded[0]?.id;
    const none = !this.expanded.length;
    const unEqId = expandId !== record?.id;
    const unEqType = this.expandType !== type;
    this.expanded = (none || unEqId || unEqType) ? [record] : [];
    this.expandType = type;
  }

  public showLink(record: IAuthedBrandRecord) {
    return this.hasBrandAuth && !record.isPublic && !!record.isOwner;
  }

  public renderRowClass(record: IAuthedBrandRecord) {
    return this.showLink(record) ? 'blue lighten-5 font-weight-bold' : '';
  }

  // 渲染缩略图
  public renderThumb(record: IAuthedBrandRecord) {
    return record.brandImage ? this.ossHost + record.brandImage : '';
  }

  public renderIsPubic(record: IAuthedBrandRecord) {
    return renderBool(!!record.isPublic, { falseColor: 'red--text' });
  }

  public renderIsOwner(record: IAuthedBrandRecord) {
    const isOwner = !!record.isPublic || !!record.isOwner;
    return renderBool(isOwner, { falseColor: 'red--text' });
  }

  public onPageChange(pagination: IPageParam) {
    this.queryAuthedBrandPage(pagination);
  }
}
